import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const consumer = {
    name: 'consumer',
    type: 'autocomplete',
    label: 'consumer',
    rules: {required: true},
    sm: 6,
    xs: 12,
}
const meter = {
    name: 'meter',
    type: 'autocomplete',
    label: 'meter',
    rules: {required: true},
    // defaultValueFieldName: 'meter._id',
    sm: 6,
    xs: 12,
}
const from_time = {
    name: 'from_date',
    rules: {required: true},
    type: 'datepicker',
    sm: 6,
    xs: 6,
}
const to_time = {
    name: 'to_date',
    rules: {required: true},
    type: 'datepicker',
    sm: 6,
    xs: 6,
}
const send_mail = {
    name: 'send_mail',
    type: 'checkbox',
    sm: 12,
    xs: 12,
}

const is_change_status = {
    name: 'is_change_status',
    type: 'checkbox',
    sm: 12,
    xs: 12,
}

export const createInvoiceField = {
    createInvoice: {
        title: 'createInvoice',
        items: {consumer, meter, from_time, to_time, send_mail, is_change_status},
    },
}

export const createInvoiceFieldValidation = z.object({
    consumer: ZodConfig.stringDocument(),
    meter: ZodConfig.stringDocument().optional(),
    from_date: ZodConfig.date(),
    to_date: ZodConfig.date(),
    send_mail: ZodConfig.boolean().optional(),
    is_change_status: ZodConfig.boolean().optional(),
})
